<div class="default-container">
  <div class="d-flex align-items-center">
    <span (click)="save(reportType)" class="save-default">Set Default Filter</span>
    <mat-icon>playlist_add</mat-icon>
  </div>
  <app-chip-label [callbackFunction]="clearDefaults"
                  [chipClass]="'on clear'"
                  [label]="'Clear Defaults'"></app-chip-label>
</div>
